/**
 * @generated SignedSource<<fe35700e5b83a433ed32e045dc7abb55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ComputeCreditsTransactionsList_transactions$data = ReadonlyArray<{
  readonly taskId: number;
  readonly " $fragmentSpreads": FragmentRefs<"ComputeCreditsTransactionRow_transaction">;
  readonly " $fragmentType": "ComputeCreditsTransactionsList_transactions";
}>;
export type ComputeCreditsTransactionsList_transactions$key = ReadonlyArray<{
  readonly " $data"?: ComputeCreditsTransactionsList_transactions$data;
  readonly " $fragmentSpreads": FragmentRefs<"ComputeCreditsTransactionsList_transactions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ComputeCreditsTransactionsList_transactions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ComputeCreditsTransactionRow_transaction"
    }
  ],
  "type": "OwnerTransaction",
  "abstractKey": null
};

(node as any).hash = "59a548c6f86ec22e60f334c4c5114104";

export default node;
